import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/utils/Stream';

export default class JumpToMid extends Modal {

  oninit(vnode) {
    super.oninit(vnode);
    const custommid = "";
    this.custommid =Stream(custommid);
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return "跳转Mid";
  }

  content() {
    const fields = this.fields().toArray();
    return (
      <div className="Modal-body">
        <div className="Form">{this.fields().toArray()}</div>
      </div>
    );
  }

  fields() {
    const items = new ItemList();

      items.add(
        'mid',
        <div className="Form-group">
          <input
            className="FormControl"
            placeholder={"请输入mid"}
            bidi={this.custommid}
            type="number"
          />
        </div>
      );

    items.add(
      'submit',
      <div className="Form-group">
        {Button.component(
          {
            className: 'Button Button--primary',
            type: 'submit',
            loading: this.loading,
          },
          "跳转"
        )}
      </div>,
      -10
    );

    return items;
  }

  onsubmit(e) {
    e.preventDefault();
    console.log(this.custommid())
    this.loading = true;
    window.location.href = "/d/" + this.custommid()

  }

}
